/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.m3-tool.js
Source: slb_src/slices/m3_tool/
Build: slb_build/build_m3_tool.mjs
Built: 2026-09-19 16:53:58.617Z
Content-SHA256: 18b03b168cc9fe9fc9e802925a44e1063e46819babcafbb48fc4747a933b16d2
Content-SHA256-12: 18b03b168cc9
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.m3-tool.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

/* SLB Admin: 3M Tools */
(function(){
  'use strict';

  if(window.__SLB_M3_TOOL_V2__) return;
  window.__SLB_M3_TOOL_V2__ = true;

  function qs(sel, root){ return (root||document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function rpc(action, args){
    try{
      if(window.SLB_APP && typeof window.SLB_APP.rpc === 'function'){
        return window.SLB_APP.rpc(action, args||{});
      }
      if(window.SLB && typeof window.SLB.rpc === 'function'){
        return window.SLB.rpc(action, args||{});
      }
    }catch(_e){}
    return Promise.reject(new Error('RPC not ready'));
  }

  function getResult(res){
    if(res && typeof res === 'object'){
      if(res.ok === false) throw new Error(res.error || 'Error');
      if(res.result != null) return res.result;
      if(res.data != null) return res.data;
    }
    return res;
  }

  function safeStr(v){ return (v==null) ? '' : String(v); }
  function trim(v){ return safeStr(v).trim(); }
  function num(v, d){ var n = Number(v); return isFinite(n) ? n : (d||0); }
  function isOn(flag){ return String(flag||'') === '1' || String(flag||'').toLowerCase() === 'true'; }

  function slugify(s){
    s = trim(s).toLowerCase();
    s = s.replace(/['"`]/g, '');
    s = s.replace(/[^a-z0-9]+/g, '-').replace(/-+/g,'-').replace(/^-|-$/g,'');
    return s || 'rest';
  }
  function genKeyFromName(name){
    var slug = slugify(name);
    var t = Date.now().toString(36);
    var rnd = Math.floor(Math.random()*46656).toString(36).padStart(3,'0');
    return 'm3r_' + slug + '_' + t + rnd;
  }

  function bootAdmin(){
    var panel = qs('#slbM3ToolPanel');
    if(!panel) return;

    // Force top orange header label (some builds fall back to raw tab key "m3Tool")
    try{
      var nowEl = document.getElementById('tywNowTab');
      if(nowEl) nowEl.textContent = '3M Tools';
    }catch(_e){}
    if(panel.dataset && panel.dataset.m3ToolMounted === '1') return;
    if(panel.dataset) panel.dataset.m3ToolMounted = '1';

    var el = {
      reload: qs('#slbM3ReloadBtn', panel),

      restPick: qs('#slbM3RestPick', panel),
      restNew: qs('#slbM3RestNewBtn', panel),
      restName: qs('#slbM3RestName', panel),
      restNote: qs('#slbM3RestNote', panel),
      restActive: qs('#slbM3RestActive', panel),
      restSort: qs('#slbM3RestSort', panel),
      restKey: qs('#slbM3RestKey', panel),
      restSave: qs('#slbM3RestSaveBtn', panel),
      restDel: qs('#slbM3RestDelBtn', panel),

      catHint: qs('#slbM3CatHint', panel),
      catTableBody: qs('#slbM3CatTable tbody', panel),
      catEmpty: qs('#slbM3CatEmpty', panel),
      catPick: qs('#slbM3CatPick', panel),
      catCustom: qs('#slbM3CatCustom', panel),
      catUse: qs('#slbM3CatUseBtn', panel),
      catClear: qs('#slbM3CatClearBtn', panel),

      itemHint: qs('#slbM3ItemHint', panel),
      itemAdd: qs('#slbM3ItemAddBtn', panel),
      itemTableBody: qs('#slbM3ItemTable tbody', panel),
      itemEmpty: qs('#slbM3ItemEmpty', panel),

      toast: qs('#slbM3ToolToast', panel)
    };

    function toast(msg){
      if(!el.toast) return;
      el.toast.textContent = msg;
      el.toast.classList.remove('hidden');
      setTimeout(function(){ try{ el.toast.classList.add('hidden'); }catch(_e){} }, 2200);
    }

    if(!rpc){
      toast('RPC is not ready.');
      return;
    }

    var state = {
      restaurants: [],
      menuItems: [],
      selectedRestKey: '',
      selectedCat: ''
    };

    function sortRestaurants(list){
      return (list||[]).slice().sort(function(a,b){
        var sa = num(a.sortOrder, 0), sb = num(b.sortOrder, 0);
        if(sa !== sb) return sa - sb;
        return safeStr(a.displayName||'').localeCompare(safeStr(b.displayName||''));
      });
    }

    function getRestByKey(key){
      key = trim(key);
      return state.restaurants.find(function(r){ return trim(r.restaurantKey) === key; }) || null;
    }

    function catsForRestaurant(restKey){
      restKey = trim(restKey);
      var map = Object.create(null);
      state.menuItems.forEach(function(it){
        if(trim(it.restaurantKey) !== restKey) return;
        var c = trim(it.category);
        if(!c) c = '(No Category)';
        map[c] = (map[c]||0) + 1;
      });
      var cats = Object.keys(map).sort(function(a,b){ return a.localeCompare(b); });
      return { map: map, list: cats };
    }

    function itemsFor(restKey, cat){
      restKey = trim(restKey);
      cat = trim(cat);
      return state.menuItems.filter(function(it){
        if(trim(it.restaurantKey) !== restKey) return false;
        if(!cat) return true;
        var c = trim(it.category);
        if(!c) c = '(No Category)';
        return c === cat;
      }).sort(function(a,b){
        var sa = num(a.sortOrder, 0), sb = num(b.sortOrder, 0);
        if(sa !== sb) return sa - sb;
        return safeStr(a.itemName||'').localeCompare(safeStr(b.itemName||''));
      });
    }

    function renderRestaurants(){
      if(!el.restPick) return;

      var opts = ['<option value="">-- Select --</option>'];
      sortRestaurants(state.restaurants).forEach(function(r){
        var key = trim(r.restaurantKey);
        var name = trim(r.displayName) || key;
        var off = isOn(r.activeFlag) ? '' : ' [OFF]';
        opts.push('<option value="' + esc(key) + '">' + esc(name + off) + '</option>');
      });
      el.restPick.innerHTML = opts.join('');

      if(state.selectedRestKey && getRestByKey(state.selectedRestKey)){
        el.restPick.value = state.selectedRestKey;
      }else{
        el.restPick.value = '';
      }

      var rest = getRestByKey(state.selectedRestKey);
      if(rest){
        el.restName.value = trim(rest.displayName);
        el.restNote.value = trim(rest.note);
        el.restActive.checked = isOn(rest.activeFlag);
        el.restSort.value = String(num(rest.sortOrder, 100));
        el.restKey.textContent = trim(rest.restaurantKey) || '—';
        el.restDel.disabled = false;
      }else{
        // New mode
        el.restName.value = '';
        el.restNote.value = '';
        el.restActive.checked = true;
        el.restSort.value = '100';
        el.restKey.textContent = 'auto';
        el.restDel.disabled = true;
      }
    }

    function renderCategories(){
      var rest = getRestByKey(state.selectedRestKey);
      if(!rest){
        el.catHint.textContent = 'Pick a restaurant first.';
        el.catTableBody.innerHTML = '';
        el.catEmpty.classList.add('hidden');
        el.catPick.innerHTML = '<option value="">--</option>';
        el.catCustom.classList.add('hidden');
        return;
      }

      el.catHint.textContent = 'Choose a category (or make a new one).';

      var cats = catsForRestaurant(state.selectedRestKey);

      // Table
      if(cats.list.length === 0){
        el.catTableBody.innerHTML = '';
        el.catEmpty.classList.remove('hidden');
      }else{
        el.catEmpty.classList.add('hidden');
        el.catTableBody.innerHTML = cats.list.map(function(c){
          var isSel = trim(state.selectedCat) === c;
          return '<tr>' +
            '<td style="font-weight:' + (isSel ? '1000' : '700') + ';">' + (isSel ? '▶ ' : '') + esc(c) + '</td>' +
            '<td style="width:90px; text-align:right;">' + esc(String(cats.map[c]||0)) + '</td>' +
            '<td style="width:110px;">' +
              '<button type="button" class="btn" data-cat="' + escAttr(c) + '">Use</button>' +
            '</td>' +
          '</tr>';
        }).join('');
      }

      // Picker
      var pickOpts = ['<option value="">-- Select --</option>'];
      cats.list.forEach(function(c){ pickOpts.push('<option value="' + esc(c) + '">' + esc(c) + '</option>'); });
      pickOpts.push('<option value="__CUSTOM__">+ Custom…</option>');
      el.catPick.innerHTML = pickOpts.join('');

      // Set picker state
      if(state.selectedCat){
        if(cats.list.indexOf(state.selectedCat) >= 0){
          el.catPick.value = state.selectedCat;
          el.catCustom.classList.add('hidden');
        }else{
          el.catPick.value = '__CUSTOM__';
          el.catCustom.classList.remove('hidden');
          el.catCustom.value = state.selectedCat;
        }
      }else{
        el.catPick.value = '';
        el.catCustom.classList.add('hidden');
        el.catCustom.value = '';
      }
    }

    function renderItems(){
      var rest = getRestByKey(state.selectedRestKey);
      if(!rest){
        el.itemHint.textContent = 'Pick a restaurant first.';
        el.itemTableBody.innerHTML = '';
        el.itemEmpty.classList.add('hidden');
        el.itemAdd.disabled = true;
        return;
      }

      var cat = trim(state.selectedCat);
      var restName = trim(rest.displayName) || trim(rest.restaurantKey);
      el.itemHint.textContent = 'Restaurant: ' + restName + (cat ? (' • Category: ' + cat) : ' • Category: All');

      // Require category for +Item to match your intended flow
      el.itemAdd.disabled = !cat;

      var list = itemsFor(state.selectedRestKey, state.selectedCat);
      if(list.length === 0){
        el.itemTableBody.innerHTML = '';
        el.itemEmpty.classList.remove('hidden');
      }else{
        el.itemEmpty.classList.add('hidden');
        el.itemTableBody.innerHTML = list.map(function(it){
          return renderItemRow(it);
        }).join('');
      }
    }

    function renderAll(){
      renderRestaurants();
      renderCategories();
      renderItems();
    }

    function loadCatalog(preserve){
      preserve = preserve !== false;
      var keepRest = preserve ? state.selectedRestKey : '';
      var keepCat = preserve ? state.selectedCat : '';

      return rpc('adminM3CatalogGet', {}).then(function(res){
        var data = getResult(res) || {};
        state.restaurants = (data.restaurants||[]).filter(function(r){ return trim(r.restaurantKey); });
        state.menuItems = (data.menuItems||[]).filter(function(m){ return trim(m.itemId); });

        // keep selection if still valid
        state.selectedRestKey = (keepRest && getRestByKey(keepRest)) ? keepRest : '';
        state.selectedCat = keepCat || '';

        // if restaurant was deleted, clear cat too
        if(!state.selectedRestKey) state.selectedCat = '';

        renderAll();
      }).catch(function(e){
        toast('Load failed: ' + safeStr(e && e.message ? e.message : e));
      });
    }

    function saveRestaurant(){
      var name = trim(el.restName.value);
      if(!name){ toast('Restaurant name is required.'); return; }

      var existing = getRestByKey(state.selectedRestKey);
      var key = existing ? trim(existing.restaurantKey) : genKeyFromName(name);
      var payload = {
        restaurantId: existing ? trim(existing.restaurantId) : '',
        restaurantKey: key,
        displayName: name,
        note: trim(el.restNote.value),
        activeFlag: el.restActive.checked ? 1 : 0,
        sortOrder: num(el.restSort.value, 100)
      };

      rpc('adminM3RestaurantUpsert', payload).then(function(res){
        var out = getResult(res) || {};
        if(out && out.ok === false) throw new Error(out.error || 'Save failed');
        toast('Saved.');
        state.selectedRestKey = key;
        return loadCatalog(true);
      }).catch(function(e){
        toast('Save failed: ' + safeStr(e && e.message ? e.message : e));
      });
    }

    function deleteRestaurant(){
      var existing = getRestByKey(state.selectedRestKey);
      if(!existing){ toast('Pick a restaurant first.'); return; }

      var name = trim(existing.displayName) || trim(existing.restaurantKey);
      if(!window.confirm('Delete restaurant "' + name + '"?')) return;

      rpc('adminM3RestaurantDelete', { restaurantId: trim(existing.restaurantId) }).then(function(res){
        var out = getResult(res) || {};
        if(out && out.ok === false) throw new Error(out.error || 'Delete failed');
        toast('Deleted.');
        state.selectedRestKey = '';
        state.selectedCat = '';
        return loadCatalog(false);
      }).catch(function(e){
        toast('Delete failed: ' + safeStr(e && e.message ? e.message : e));
      });
    }

    function addNewRestaurant(){
      state.selectedRestKey = '';
      state.selectedCat = '';
      renderAll();
      try{ el.restName.focus(); }catch(_e){}
    }

    function useCategory(cat){
      cat = trim(cat);
      if(!cat){ toast('Category is required.'); return; }
      state.selectedCat = cat;
      renderCategories();
      renderItems();
    }

    function readCatFromPicker(){
      var v = trim(el.catPick.value);
      if(v === '__CUSTOM__') v = trim(el.catCustom.value);
      return v;
    }

    function renderItemRow(it){
      var id = trim(it.itemId);
      var sortOrder = num(it.sortOrder, 100);
      var on = isOn(it.activeFlag);
      var name = trim(it.itemName);
      var price = num(it.priceStones, 0);
      var imageUrl = trim(it.imageUrl);
      var imageState = imageUrl ? ('Linked • <a href="' + escAttr(imageUrl) + '" target="_blank" rel="noopener">Open</a>') : 'No image';
      var rowCat = trim(it.category);

      return '<tr data-item-id="' + escAttr(id) + '" data-category="' + escAttr(rowCat) + '">' +
        '<td>' +
          '<button type="button" class="btn" data-act="save">Save</button> ' +
          '<button type="button" class="btn" data-act="image">Image</button> ' +
          '<button type="button" class="btn" data-act="del">Del</button>' +
          '<div class="note" style="margin-top:6px; font-size:12px;">' + imageState + '</div>' +
          '<input type="hidden" data-f="imageUrl" value="' + escAttr(imageUrl) + '" />' +
        '</td>' +
        '<td><input class="inp" type="number" data-f="sort" value="' + escAttr(String(sortOrder)) + '" /></td>' +
        '<td style="text-align:center;"><input type="checkbox" data-f="on" ' + (on ? 'checked' : '') + ' /></td>' +
        '<td><input class="inp" type="text" data-f="name" value="' + escAttr(name) + '" placeholder="Item name" /></td>' +
        '<td><input class="inp" type="number" data-f="price" value="' + escAttr(String(price)) + '" /></td>' +
      '</tr>';
    }

    function addItemRow(){
      var rest = getRestByKey(state.selectedRestKey);
      if(!rest){ toast('Pick a restaurant first.'); return; }
      var cat = trim(state.selectedCat);
      if(!cat){ toast('Pick a category (or custom) first.'); return; }

      // Insert a blank draft row on top (not yet saved)
      var tr = document.createElement('tr');
      tr.dataset.itemId = '';
      tr.dataset.draft = '1';
      tr.dataset.category = cat === '(No Category)' ? '' : cat;
      tr.innerHTML =
        '<td>' +
          '<button type="button" class="btn" data-act="save">Save</button> ' +
          '<button type="button" class="btn" data-act="image">Image</button> ' +
          '<button type="button" class="btn" data-act="del">Del</button>' +
          '<div class="note" style="margin-top:6px; font-size:12px;">No image</div>' +
          '<input type="hidden" data-f="imageUrl" value="" />' +
        '</td>' +
        '<td><input class="inp" type="number" data-f="sort" value="100" /></td>' +
        '<td style="text-align:center;"><input type="checkbox" data-f="on" checked /></td>' +
        '<td><input class="inp" type="text" data-f="name" value="" placeholder="Item name" /></td>' +
        '<td><input class="inp" type="number" data-f="price" value="0" /></td>';

      el.itemEmpty.classList.add('hidden');
      if(el.itemTableBody.firstChild) el.itemTableBody.insertBefore(tr, el.itemTableBody.firstChild);
      else el.itemTableBody.appendChild(tr);
      try{ tr.querySelector('[data-f="name"]').focus(); }catch(_e){}
    }

    function setRowSaving(tr, isSaving){
      var btns = qsa('button', tr);
      btns.forEach(function(btn){ btn.disabled = !!isSaving; });
      var saveBtn = qs('button[data-act="save"]', tr);
      if(saveBtn){
        if(isSaving){
          if(!saveBtn.dataset.originalText) saveBtn.dataset.originalText = saveBtn.textContent || 'Save';
          saveBtn.textContent = 'Saving...';
        }else{
          saveBtn.textContent = saveBtn.dataset.originalText || 'Save';
        }
      }
      if(isSaving) tr.setAttribute('aria-busy', 'true');
      else tr.removeAttribute('aria-busy');
    }

    function saveItemRow(tr){
      var rest = getRestByKey(state.selectedRestKey);
      if(!rest){ toast('Pick a restaurant first.'); return; }
      var cat = trim(state.selectedCat) || trim((tr && tr.dataset && tr.dataset.category) || '');
      if(!cat && tr && tr.dataset && tr.dataset.draft === '1'){
        toast('Pick a category first.');
        return;
      }

      var nameEl = qs('[data-f="name"]', tr);
      var priceEl = qs('[data-f="price"]', tr);
      var sortEl = qs('[data-f="sort"]', tr);
      var onEl = qs('[data-f="on"]', tr);
      var imageEl = qs('[data-f="imageUrl"]', tr);
      var itemId = trim(tr.dataset.itemId);
      var name = trim(nameEl && nameEl.value);
      if(!name){ toast('Item name is required.'); return; }

      var payload = {
        itemId: itemId,
        restaurantKey: trim(rest.restaurantKey),
        category: cat === '(No Category)' ? '' : cat,
        itemName: name,
        note: '',
        imageUrl: trim((imageEl || {}).value || ''),
        priceStones: num(priceEl && priceEl.value, 0),
        sortOrder: num(sortEl && sortEl.value, 100),
        activeFlag: onEl && onEl.checked ? 1 : 0
      };

      tr.dataset.category = payload.category;
      setRowSaving(tr, true);
      toast('Saving item...');
      Promise.resolve(rpc('adminM3MenuUpsert', payload)).then(function(res){
        var out = getResult(res) || {};
        if(out && out.ok === false) throw new Error(out.error || 'Save failed');
        toast('Saved.');
        return loadCatalog(true);
      }).catch(function(e){
        toast('Save failed: ' + safeStr(e && e.message ? e.message : e));
      }).finally(function(){
        setRowSaving(tr, false);
      });
    }

    function editItemImageRow(tr){
      var input = qs('[data-f="imageUrl"]', tr);
      if(!input){ toast('Image field missing.'); return; }
      var current = trim(input.value);
      var next = window.prompt('Paste Shopify CDN image URL for this item. Leave blank to remove.', current);
      if(next == null) return;
      next = trim(next);
      if(next && !/^https?:\/\//i.test(next)){
        toast('Please use a full https:// image URL.');
        return;
      }
      input.value = next;
      var note = qs('.note', tr);
      if(note) note.innerHTML = next ? ('Linked • <a href="' + escAttr(next) + '" target="_blank" rel="noopener">Open</a>') : 'No image';
      toast(next ? 'Image URL updated in row. Click Save.' : 'Image URL cleared. Click Save.');
    }

    function deleteItemRow(tr){
      var itemId = trim(tr.dataset.itemId);
      if(!itemId){
        try{ tr.parentNode.removeChild(tr); }catch(_e){}
        return;
      }
      if(!window.confirm('Delete this item?')) return;

      rpc('adminM3MenuDelete', { itemId: itemId }).then(function(res){
        var out = getResult(res) || {};
        if(out && out.ok === false) throw new Error(out.error || 'Delete failed');
        toast('Deleted.');
        return loadCatalog(true);
      }).catch(function(e){
        toast('Delete failed: ' + safeStr(e && e.message ? e.message : e));
      });
    }

    // Escaping helpers
    function esc(s){
      s = safeStr(s);
      return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
    function escAttr(s){
      return esc(s).replace(/\n/g,' ');
    }

    // ===== Events =====
    if(el.reload) el.reload.addEventListener('click', function(){ loadCatalog(true); });

    el.restPick.addEventListener('change', function(){
      state.selectedRestKey = trim(el.restPick.value);
      state.selectedCat = '';
      renderAll();
    });

    el.restNew.addEventListener('click', function(){
      addNewRestaurant();
      toast('Add a new restaurant, then Save.');
    });

    el.restSave.addEventListener('click', saveRestaurant);
    el.restDel.addEventListener('click', deleteRestaurant);

    el.catPick.addEventListener('change', function(){
      var v = trim(el.catPick.value);
      if(v === '__CUSTOM__'){
        el.catCustom.classList.remove('hidden');
        try{ el.catCustom.focus(); }catch(_e){}
      }else{
        el.catCustom.classList.add('hidden');
      }
    });

    el.catUse.addEventListener('click', function(){
      var c = readCatFromPicker();
      if(!c){ toast('Pick a category (or custom) first.'); return; }
      useCategory(c);
    });

    el.catClear.addEventListener('click', function(){
      state.selectedCat = '';
      renderCategories();
      renderItems();
    });

    // Category table "Use" buttons
    el.catTableBody.addEventListener('click', function(ev){
      var btn = ev && ev.target ? ev.target.closest('button[data-cat]') : null;
      if(!btn) return;
      var cat = btn.getAttribute('data-cat');
      useCategory(cat);
    });

    // Items
    el.itemAdd.addEventListener('click', addItemRow);
    el.itemTableBody.addEventListener('click', function(ev){
      var btn = ev && ev.target ? ev.target.closest('button[data-act]') : null;
      if(!btn) return;
      var tr = btn.closest('tr');
      if(!tr) return;
      var act = btn.getAttribute('data-act');
      if(act === 'save') saveItemRow(tr);
      if(act === 'image') editItemImageRow(tr);
      if(act === 'del') deleteItemRow(tr);
    });

    // Initial load
    loadCatalog(false);
  }

  // Try boot now, and also on tab switches (SLB fires events)
  try{ bootAdmin(); }catch(_e){}
  document.addEventListener('slb:tab:admin', function(){ try{ bootAdmin(); }catch(_e){} });
  document.addEventListener('slb:tab:m3Tool', function(){ try{ bootAdmin(); }catch(_e){} });

})();

